<script setup lang="ts">

import type {InputField} from "~/constants/types/serviceInputs";

const props = defineProps<{
  field: InputField
}>();
const route = useRoute();
const isBccPage = computed(() => route.name === 'bcc');
const visibleOptions = computed(() => {
  if (!isBccPage.value) return props.field.options;
  return props.field.options.filter((option) => option.value !== 'warehouse' && option.value !== 'boutique');
});
if (!props.field.option){
  props.field.option = props.field.options.find((option)=>option.option_id === props.field.default_value)?.option ;
}
const handleSelect = (id: string,option:string) => {
  props.field.default_value = id;
  props.field.option=option;
};
watch(useStoreSelectedServiceId(),()=>{
  props.field.option = props.field.options.find((option)=>option.option_id === props.field.default_value)?.option ;
},{immediate:true})
const selected = computed(() => props.field.default_value);
</script>

<template>
  <div class="grid grid-cols-2 gap-3">
    <button
        v-for="option in visibleOptions"
        @click="handleSelect(option.option_id,option.option)"
        class="py-[6px] px-2 text-sm md:text-base rounded-xl h-12 border transition duration-50 ease-in whitespace-nowrap font-bold"
        :class="selected === option.option_id ? 'border-primary-green bg-primary-green bg-opacity-5 text-primary-green' : 'border-neutral-light-gray'"
    >
      {{ option.option }}
    </button>
  </div>
</template>

<style scoped>

</style>